import { Employee } from "domain/entities/employee";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface EmployeeState {
  employee: Employee | null;
  setEmployee: (newEmployee: Partial<Employee>) => void;
  resetEmployee: () => void;
}

const initialEmployeeState: Employee = {
  id: "",
  name: "",
  address: "",
  complement: "",
  postalCode: "",
  city: "",
  country: "",
  phoneNumber: "",
  emailAddress: "",
  birthDate: null,
  maritalStatus: "",
  childrenNumber: 0,
  bankAccount: "",
  carOwner: "",
  carRegistration: "",
  vacationDaysCurrentYear: 0,
  vacationDaysLastYear: 0,
  contractType: "",
  employeeNumber: 0,
  isActive: false,
  jobTitle: { id: "", name: "", isPeopleManager: false },
  workLocation: "",
  workCountry: "",
  workType: "",
  idDocumentNumber: "",
  fiscalIdNumber: "",
  drivingLicenceNumber: "",
  hasDrivingLicence: false,
  socialSecurityNumber: "",
  idDocumentType: "",
  personalEmail: "",
  photo: "",
  observations: "",
  managerAssociated: { id: "", name: "" },
  emergencyContactName: "",
  emergencyContactRelation: "",
  emergencyContactPhone: "",
  rfiExpiresAt: null,
  admissionDate: null,
  terminationDate: null,
  isSuportService: false,
  professionalPhoneNumber: "",
  isRemoteWorker: false,
  workHoursPerDay: 0,
  createdAt: new Date(),
  modifiedAt: new Date(),
  lastModifiedBy: "",
  salary: null,
};

export const useEmployeeStore = create<EmployeeState>()(
  devtools(
    (set) => ({
      employee: initialEmployeeState,
      setEmployee: (newEmployee) =>
        set((state) => ({
          employee: { ...state.employee, ...newEmployee } as Employee,
        })),
      resetEmployee: () => set({ employee: initialEmployeeState }),
    }),
    { name: "EmployeeSelected" },
  ),
);
